import { MarkerGroupNamings, MarkerGroups, REFER_MARKERS } from "../../constant/markerConstant";

export type FinancialCrimeFlags = {
  moneyIn: boolean;
  moneyOut: boolean;
  buyTrades: boolean;
  sellTrades: boolean;
  transferIn: boolean;
  transferOut: boolean;
}

export type Marker = {
  code: string;
  description: string;
  groupCode: string;
  groupDescription: string;
  userSelectable: boolean;
  isRestrictive: boolean;
  isReferred: boolean;
  financialCrimeFlag: FinancialCrimeFlags;
}

export type InvestorMarker = Marker & {
  dateAdded: string;
  addedBy: string;
  comments: string;
  removed: boolean;
}

export function markerTransformer(row: any) {
  const groupCode = row.groupCode || MarkerGroups.NONE;
  const financialCrimeFlag = financialCrimeFlagTransformer(row.financialCrimeFlag);
  return {
    code: row.markerCode,
    description: row.description,
    groupCode,
    groupDescription: MarkerGroupNamings[groupCode as keyof (typeof MarkerGroupNamings)],
    userSelectable: row.userSelectable === "Y",
    isRestrictive: isRestrictive(financialCrimeFlag),
    isReferred: isReferredMarker(row.markerCode),
    financialCrimeFlag: financialCrimeFlag,
  };
}

function financialCrimeFlagTransformer(data: any): FinancialCrimeFlags {
  return {
    moneyIn: data?.moneyIn === "Y",
    moneyOut: data?.moneyOut === "Y",
    buyTrades: data?.buyTrades === "Y",
    sellTrades: data?.sellTrades === "Y",
    transferIn: data?.transferIn === "Y",
    transferOut: data?.transferOut === "Y"
  };
}

function isRestrictive(flags: FinancialCrimeFlags) {
  const restrictiveAttributes: (keyof FinancialCrimeFlags)[] = ["moneyIn", "moneyOut", "buyTrades", "sellTrades", "transferIn", "transferOut"];
  return restrictiveAttributes.map((key) => flags[key]).some((el) => el);
}

function isReferredMarker(code: string) {
  return REFER_MARKERS.includes(code);
}

export function investorMarkerTransformer(row: any, markers: Marker[]): InvestorMarker {
  const marker = markers.find(el => el.code === row.markerCode);
  return {
    ...marker!,
    dateAdded: row.createdOnDate,
    addedBy: getOperator(row.createdByUser, row.createdByJob),
    comments: row.commentLine1 + row.commentLine2 + row.commentLine3 + row.commentLine4,
    removed: Boolean(row.removedByTime),
  };
}

export function getOperator(user: string, job: string) {
  const fullString = user + job;
  if (fullString.includes("-")) {
    return fullString.split("-")[1];
  } else {
    return job;
  }
}

export type InvestorMarkerUpdatePayload = {
  comments: string;
}

export type InvestorMarkerAddPayload = {
  markerCode: string;
  groupCode?: string;
  comment?: string;
  previousMarkerCode?: string;
}
